import React, { useState, useEffect, useRef, Fragment } from 'react'
import { connect } from 'react-redux'
import {
  IFText,
  IFFilter,
  IFSkeleton,
  IFsvg,
  IFTooltipIconsLoading,
  IFTextInput,
  IFToastMessage,
  StatePicker,
  IFDialog,
} from 'Components'
import {
  ChargingTokenTransactionList,
  ChargingTokenDetailsTabs,
  OperatorUserActionsChargingToken,
  CardSessionsList,
  CardUsageStats,
} from 'Containers'
import { Colors } from 'Theme'
import Styles from './ChargingTokensDetails.module.css'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import RequestState from 'Enums/RequestState'
import Icon from '@mui/material/Icon'
import DateRangeIcon from '@mui/icons-material/DateRange'
import moment from 'moment'
import styled from 'styled-components'
import InfinityEnums from 'Enums/InfinityEnums'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import RefreshIcon from '@mui/icons-material/Refresh'
import { SelectPicker } from 'rsuite'
import CardSelectors from 'Stores/Card/Selectors'
import AuthSelectors from 'Stores/Auth/Selectors'
import CardActions from 'Stores/Card/Actions'
import { toaster } from 'rsuite'
import OperatorUserActionsAction from 'Stores/OperatorUserActions/Actions'
import OperatorUserActionsSelectors from 'Stores/OperatorUserActions/Selectors'
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react'

const LeftContainer = styled.div`
  border-right: ${(props) => (props.underOperator ? '1px' : '0px')} solid
    ${Colors.DividerColor};
`

const ChargingTokensDetails = ({
  selectedCard,
  selectedIndex,
  fetchCardListRequestState,
  fetchCardRequestState,
  cardsTransactionsFilter,
  cardsList,
  fetchCard,
  clearCardTransactions,
  resetCardState,
  setCardTransactionsFilter,
  setCardsTransactionPaginationOffset,
  fetchCardTransactions,
  fetchCardTransactionsRequestState,
  deleteCard,
  deleteCardRequestState,
  cardTransactions,
  updateCard,
  updateCardRequestState,
  fetchOperatorUserActionsChargingToken,
  setOperatorUserActionsFilter,
  resetOperatorUserActionsChargingToken,
  operatorUser,
  operatorUserActionsFilters,
  fetchOperatorUserActionsChargingTokenRequestState,
  setOperatorUserActionsChargingTokenPaginationOffset,
  resetUpdateCardRequestStates,
  cardSessions,
  fetchCardSessionListRequestState,
}) => {
  const { t } = useTranslation()
  const chargingTokenDetailsTabsRef = useRef()
  const [selectedDetails, setSelectedDetails] = useState(0)
  const confirmDeleteDialog = useRef()
  const refDiv = useRef()
  const overlayscrollbarsRef = useRef(null)

  const [isEdit, setIsEdit] = useState(false)
  const [ascendingTransactions, setAscendingTransactions] = useState(false)
  const [height, setHeight] = useState(0)
  const [refreshingTransactions, setRefreshingTransactions] = useState(false)
  const [refreshingOperatorUserActions, setRefreshingOperatorUserActions] =
    useState(false)
  const [transactionListLastUpdated, setTransactionListLastUpdated] =
    useState(null)
  const [operatorUserActionsLastUpdated, setOperatorUserActionsLastUpdated] =
    useState(null)
  const [contractIdEdit, setcontractIdEdit] = useState(selectedCard?.contractId)
  const [uidEdit, setUidEdit] = useState(selectedCard?.huid)
  const [typeEdit, setTypeEdit] = useState(selectedCard?.type)
  const [statusEdit, setStatusEdit] = useState(selectedCard?.status)
  const [empty, setEmpty] = useState(true)
  const transactionRef = useRef()
  const operatorUserRef = useRef()

  useEffect(() => {
    if (selectedCard) {
      setIsEdit(false)
      setCardsTransactionPaginationOffset(0)
      clearCardTransactions()
      resetCardState()
      fetchCard(selectedCard._id)

      setTransactionListLastUpdated(null)
      setOperatorUserActionsLastUpdated(null)

      if (chargingTokenDetailsTabsRef.current) {
        chargingTokenDetailsTabsRef.current.resetIndex()
        setSelectedDetails(0)
      }
    }
  }, [selectedCard?._id])

  useEffect(() => {
    if (selectedCard && selectedDetails === 0) {
      fetchCardTransactions(
        cardsTransactionsFilter,
        0,
        selectedCard._id,
        ascendingTransactions,
      )
      resetOperatorUserActionsChargingToken()
    }
    if (selectedDetails !== undefined) {
      transactionRef?.current?.clearFilter()
      operatorUserRef?.current?.clearFilter()
    }
  }, [selectedDetails])

  useEffect(() => {
    if (selectedCard) {
      setCardsTransactionPaginationOffset(0)
      fetchCardTransactions(
        cardsTransactionsFilter,
        0,
        selectedCard._id,
        ascendingTransactions,
      )
    }
  }, [cardsTransactionsFilter])
  useEffect(() => {
    if (selectedCard) {
      setcontractIdEdit(selectedCard?.contractId)
      setUidEdit(selectedCard?.huid)
      setTypeEdit(selectedCard?.type)
      setStatusEdit(selectedCard?.status)
    }
  }, [selectedCard])
  useEffect(() => {
    if (
      fetchCardTransactionsRequestState !== RequestState.LOADING &&
      fetchCardTransactionsRequestState !== RequestState.UNINITIALIZED
    ) {
      setRefreshingTransactions(false)
      setTransactionListLastUpdated(Date.now())
    }
  }, [fetchCardTransactionsRequestState])

  useEffect(() => {
    if (
      fetchOperatorUserActionsChargingTokenRequestState !==
        RequestState.LOADING &&
      fetchOperatorUserActionsChargingTokenRequestState !==
        RequestState.UNINITIALIZED
    ) {
      setRefreshingOperatorUserActions(false)
      setOperatorUserActionsLastUpdated(Date.now())
    }
  }, [fetchOperatorUserActionsChargingTokenRequestState])
  useEffect(() => {
    // max list height container height - padding,title,add button
    if (refDiv && refDiv.current) {
      setHeight(refDiv.current.getBoundingClientRect().height - 130)
    }
  }, [refDiv, selectedCard, isEdit])

  useEffect(() => {
    if (deleteCardRequestState === RequestState.SUCCEEDED) {
      if (confirmDeleteDialog.current) confirmDeleteDialog.current.dismiss()
      resetCardState()
      setIsEdit(false)
    }
  }, [deleteCardRequestState])

  useEffect(() => {
    if (updateCardRequestState === RequestState.SUCCEEDED) {
      resetUpdateCardRequestStates()
      toaster.push(
        <IFToastMessage
          type="success"
          text={t('ToasterMessages.CardUpdated')}
        />,
        {
          placement: 'topEnd',
        },
      )
    }
  }, [updateCardRequestState])
  const handleCancel = () => {
    setIsEdit(false)
    setcontractIdEdit(selectedCard?.contractId)
    setUidEdit(selectedCard?.huid)
    setTypeEdit(selectedCard?.type)
    setStatusEdit(selectedCard?.status)
  }
  useEffect(() => {
    if (updateCardRequestState === RequestState.SUCCEEDED) {
      setIsEdit(false)
    }
  }, [updateCardRequestState])

  const handleSubmit = () => {
    let newCard = {}
    if (contractIdEdit !== selectedCard.contractId)
      newCard.contractId = contractIdEdit
    if (uidEdit !== selectedCard.huid) newCard.huid = uidEdit
    if (typeEdit !== selectedCard.type) newCard.type = typeEdit
    if (statusEdit !== selectedCard.status) newCard.status = statusEdit
    if (Object.keys(newCard).length > 0) {
      updateCard(selectedCard._id, newCard, selectedIndex)
    } else {
      setIsEdit(false)
    }
  }

  const handleCardTransactions = (newFilter) => {
    clearCardTransactions()
    setCardTransactionsFilter(newFilter)
  }

  const handleSubmitRef = useRef(handleSubmit)

  useEffect(() => {
    handleSubmitRef.current = handleSubmit
  })

  const handleSelectedTab = (index) => {
    setSelectedDetails(index)
  }

  useEffect(() => {
    if (overlayscrollbarsRef.current?.osInstance()) {
      overlayscrollbarsRef.current.osInstance().elements().viewport.scrollTo({
        top: 0,
        behavior: 'auto',
      })
    }
  }, [selectedCard?._id])

  return (
    <Fragment>
      <div className={Styles.Container}>
        <LeftContainer
          className={Styles.LeftContainer}
          underOperator={
            fetchCardListRequestState === RequestState.LOADING ||
            (cardsList.length > 0 && selectedCard)
              ? true
              : false
          }
        >
          <div className={Styles.CardDetailsContainer}>
            <div>
              {fetchCardListRequestState === RequestState.LOADING ||
              fetchCardRequestState === RequestState.LOADING ? (
                <div>
                  <div className={Styles.CardInfoSkeletonContainer}>
                    <IFSkeleton variant="text" width="6rem" height="1.75rem" />
                    <IFSkeleton
                      style={{ marginLeft: '1rem' }}
                      variant="text"
                      width="6rem"
                      height="1.75rem"
                    />
                  </div>
                  <div className={Styles.CardInfoSkeletonContainer}>
                    <IFSkeleton
                      variant="circular"
                      width="1.25rem"
                      height="1.25rem"
                    />
                    <IFSkeleton
                      className={Styles.CardInfoSkeleton}
                      variant="text"
                      width="10rem"
                      height="1.5rem"
                    />
                  </div>
                  <div className={Styles.CardInfoSkeletonContainer}>
                    <IFSkeleton
                      variant="circular"
                      width="1.25rem"
                      height="1.25rem"
                    />
                    <IFSkeleton
                      className={Styles.CardInfoSkeleton}
                      variant="text"
                      width="13rem"
                      height="1.5rem"
                    />
                  </div>
                  <div className={Styles.CardInfoSkeletonContainer}>
                    <IFSkeleton
                      variant="circular"
                      width="1.25rem"
                      height="1.25rem"
                    />
                    <IFSkeleton
                      className={Styles.CardInfoSkeleton}
                      variant="text"
                      width="10rem"
                      height="1.5rem"
                    />
                  </div>
                </div>
              ) : (
                <div>
                  <div className={Styles.ReferenceContainer}>
                    {selectedCard && (
                      <StatePicker
                        options={Object.values(
                          InfinityEnums.ChargingTokenStatus,
                        ).map((status) => {
                          return {
                            label: status,
                            value: status,
                            color: Colors.ChargingtokenStatus[status],
                          }
                        })}
                        defaultOptionIndex={Object.values(
                          InfinityEnums.ChargingTokenStatus,
                        )
                          .map((status) => {
                            return {
                              label: status,
                              value: status,
                              color: Colors.ChargingtokenStatus[status],
                            }
                          })
                          .findIndex(
                            (option) => option.value === selectedCard?.status,
                          )}
                        isEdit={isEdit || selectedCard?.isActivated === false}
                        onPrivacyChange={(value) => setStatusEdit(value)}
                      />
                    )}
                  </div>

                  <div className={Styles.InfoIconContainer}>
                    <IFsvg.Tag
                      className={Styles.Icon}
                      height={20}
                      width={20}
                      fill={Colors.black}
                    />
                    <div className={Styles.InfoTextContainer}>
                      {isEdit ? (
                        <IFTextInput
                          value={uidEdit}
                          fontSize={14}
                          onChange={(e) => setUidEdit(e.target.value)}
                        />
                      ) : (
                        <IFText
                          className={Styles.InfoText}
                          style={{ color: Colors.text }}
                        >
                          {selectedCard?.huid}
                        </IFText>
                      )}
                    </div>
                  </div>

                  <div className={Styles.InfoIconContainer}>
                    <IFsvg.VisibleFilled
                      height={20}
                      width={20}
                      fill={Colors.black}
                      className={Styles.Icon}
                    />
                    <div className={Styles.InfoTextContainer}>
                      {isEdit ? (
                        <IFTextInput
                          value={contractIdEdit}
                          fontSize={14}
                          onChange={(e) => setcontractIdEdit(e.target.value)}
                        />
                      ) : (
                        <IFText
                          className={Styles.InfoText}
                          style={{ color: Colors.text }}
                        >
                          {selectedCard?.contractId
                            ? selectedCard.contractId
                            : '-'}
                        </IFText>
                      )}
                    </div>
                  </div>

                  <div className={Styles.InfoIconContainer}>
                    {isEdit ? null : selectedCard?.type ===
                      InfinityEnums.ChargingTokenType.RFID ? (
                      <IFsvg.Card height={20} width={20} fill={Colors.black} />
                    ) : (
                      <IFsvg.VirtualToken
                        height={20}
                        width={20}
                        fill={Colors.black}
                      />
                    )}
                    <div className={Styles.TypeContainer}>
                      {isEdit ? (
                        <div className={Styles.TypeSelectPicker}>
                          <SelectPicker
                            className={Styles.SelectPicker}
                            appearance="subtle"
                            renderValue={(value) => (
                              <div
                                className={Styles.SelectPickerValueContainer}
                              >
                                {value ===
                                InfinityEnums.ChargingTokenType.RFID ? (
                                  <IFsvg.Card
                                    height={20}
                                    width={20}
                                    fill={Colors.black}
                                    className={Styles.Icon}
                                  />
                                ) : (
                                  <IFsvg.VirtualToken
                                    height={20}
                                    width={20}
                                    fill={Colors.black}
                                    className={Styles.Icon}
                                  />
                                )}
                                <IFText
                                  className={Styles.SelectPickerText}
                                  style={{
                                    color: Colors.text,
                                  }}
                                >
                                  {typeEdit}
                                </IFText>
                              </div>
                            )}
                            defaultValue={typeEdit}
                            value={typeEdit}
                            onSelect={(value) => {
                              setTypeEdit(value)
                            }}
                            renderMenuItem={(item) => (
                              <div className={Styles.RenderMenuItemContainer}>
                                {item ===
                                InfinityEnums.ChargingTokenType.RFID ? (
                                  <IFsvg.Card
                                    height={20}
                                    width={20}
                                    fill={Colors.black}
                                    className={Styles.Icon}
                                  />
                                ) : (
                                  <IFsvg.VirtualToken
                                    height={20}
                                    width={20}
                                    fill={Colors.black}
                                    className={Styles.Icon}
                                  />
                                )}
                                <IFText className={Styles.SelectPickerText}>
                                  {item}
                                </IFText>
                              </div>
                            )}
                            data={Object.keys(
                              InfinityEnums.ChargingTokenType,
                            ).map((key) => {
                              return {
                                label: InfinityEnums.ChargingTokenType[key],
                                value: InfinityEnums.ChargingTokenType[key],
                              }
                            })}
                            cleanable={false}
                            size="xs"
                            searchable={false}
                          />
                        </div>
                      ) : (
                        <IFText
                          className={Styles.TypeText}
                          style={{ color: Colors.text }}
                        >
                          {selectedCard?.type}
                        </IFText>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {fetchCardListRequestState === RequestState.LOADING ||
            cardsList.length > 0 ? (
              <div
                style={{ color: Colors.black }}
                className={Styles.DateWrapper}
              >
                {fetchCardListRequestState === RequestState.LOADING ||
                fetchCardRequestState === RequestState.LOADING ? (
                  <IFSkeleton variant="text" width="8rem" height=" 1.5rem" />
                ) : (
                  <div className={Styles.DateContainer}>
                    <Icon
                      sx={{ fontSize: '16px !important' }}
                      component={DateRangeIcon}
                    />
                    <IFText>
                      &nbsp;
                      {selectedCard
                        ? moment(selectedCard.updatedAt).format(
                            'MMM DD, YYYY HH:mm',
                          )
                        : ''}
                    </IFText>
                  </div>
                )}
              </div>
            ) : null}
          </div>
          <OverlayScrollbarsComponent
            ref={overlayscrollbarsRef}
            defer
            options={{
              scrollbars: {
                visibility: 'auto',
                autoHide: 'move',
                autoHideDelay: 1000,
              },
            }}
            className={Styles.OverlayScrollbarsComponent}
          >
            {!isEdit && <CardUsageStats />}
            {!isEdit && (
              <div className={Styles.SpecsSessionsContainer}>
                <div className={Styles.SessionsContainer}>
                  {fetchCardListRequestState === RequestState.LOADING ||
                  fetchCardRequestState === RequestState.LOADING ||
                  fetchCardSessionListRequestState === RequestState.LOADING ? (
                    <IFSkeleton
                      className={Styles.OngoingSessions}
                      width="7rem"
                      height="2rem"
                    />
                  ) : (
                    <IFText
                      className={Styles.OngoingSessions}
                      style={{ color: Colors.text }}
                    >
                      {t('CardsPage.OngoingSessions')}
                    </IFText>
                  )}
                  <div
                    className={Styles.Sessions}
                    style={cardSessions.length >= 3 ? { height: '14rem' } : {}}
                  >
                    <CardSessionsList />
                  </div>
                </div>
              </div>
            )}
            {!isEdit && (
              <div className={Styles.TransactionsContainer}>
                <div className={Styles.TransactionsTitlesContainer}>
                  {fetchCardListRequestState === RequestState.LOADING ||
                  fetchCardRequestState === RequestState.LOADING ||
                  !transactionListLastUpdated ? (
                    <div className={Styles.TransactionLogContainer}>
                      <IFSkeleton
                        variant="text"
                        width="7rem"
                        height="1.75rem"
                      />
                    </div>
                  ) : (
                    <div className={Styles.TransactionLogContainer}>
                      <ChargingTokenDetailsTabs
                        initialIndex={selectedDetails}
                        ref={chargingTokenDetailsTabsRef}
                        onValueChange={(index) => {
                          handleSelectedTab(index)
                        }}
                        isLoading={
                          fetchCardListRequestState === RequestState.LOADING ||
                          fetchCardRequestState === RequestState.LOADING
                        }
                        canViewOperatorUserActions={operatorUser.permissions.includes(
                          InfinityEnums.OperatorUserPermission
                            .CAN_VIEW_OPERATOR_USER_ACTIONS_CHARGE_TOKEN,
                        )}
                      />
                    </div>
                  )}
                  {fetchCardListRequestState === RequestState.LOADING ||
                  fetchCardRequestState === RequestState.LOADING ||
                  fetchCardTransactionsRequestState === RequestState.LOADING ||
                  fetchOperatorUserActionsChargingTokenRequestState ===
                    RequestState.LOADING ? (
                    <div className={Styles.RefreshIconTextContainer}>
                      <div>
                        <IFSkeleton
                          height="1.5rem"
                          className={Styles.RefreshTextSkeleton}
                        />
                        <IFSkeleton
                          height="1.25rem"
                          className={Styles.RefreshTextDateSkeleton}
                        />
                      </div>
                      <div
                        className={Styles.RefreshIcon}
                        style={{ marginBottom: '0.5rem' }}
                      >
                        <IFSkeleton
                          width="1.5rem"
                          height="1.5rem"
                          variant="circular"
                        />
                      </div>
                    </div>
                  ) : (
                    <div className={Styles.RefreshIconTextContainer}>
                      <div className={Styles.RefreshTextContainer}>
                        <IFText
                          className={Styles.RefreshText}
                          style={{ color: Colors.black }}
                        >
                          {t('ChargePointDetails.lastUpdated')}
                        </IFText>
                        <IFText className={Styles.RefreshTextDate}>
                          {selectedDetails === 0 && transactionListLastUpdated
                            ? moment(transactionListLastUpdated).format(
                                'MMM DD, YYYY HH:mm:ss',
                              )
                            : selectedDetails === 1 &&
                              operatorUserActionsLastUpdated
                            ? moment(operatorUserActionsLastUpdated).format(
                                'MMM DD, YYYY HH:mm:ss',
                              )
                            : ''}
                        </IFText>
                      </div>
                      <div
                        className={Styles.RefreshIcon}
                        onClick={() => {
                          if (selectedDetails === 0) {
                            if (refreshingTransactions) return
                            setRefreshingTransactions(true)
                            setCardsTransactionPaginationOffset(0)
                            fetchCardTransactions(
                              cardsTransactionsFilter,
                              0,
                              selectedCard._id,
                              ascendingTransactions,
                            )
                          } else if (selectedDetails === 1) {
                            if (refreshingOperatorUserActions) return
                            setRefreshingOperatorUserActions(true)
                            setOperatorUserActionsChargingTokenPaginationOffset(
                              0,
                            )
                            fetchOperatorUserActionsChargingToken(
                              selectedCard._id,
                              operatorUserActionsFilters,
                              0,
                            )
                          }
                        }}
                      >
                        <RefreshIcon
                          sx={{ height: '20px' }}
                          className={
                            refreshingTransactions ? Styles.refreshStart : null
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className={Styles.FilterContainer}>
                  {!(
                    fetchCardTransactionsRequestState ===
                      RequestState.SUCCEEDED &&
                    cardTransactions.length === 0 &&
                    !empty
                  ) &&
                    (selectedDetails === 0 ? (
                      <IFFilter
                        ref={transactionRef}
                        key={'IFFilter_CardDetails_Transactions'}
                        onFilterChange={(newFilter) => {
                          handleCardTransactions(newFilter)
                        }}
                        filters={cardsTransactionsFilter}
                        textFieldPlaceholder={t('CardDetails.FilterLogsBy')}
                        downloadTransactions={false}
                        isLoading={
                          fetchCardListRequestState === RequestState.LOADING ||
                          fetchCardRequestState === RequestState.LOADING ||
                          (fetchCardTransactionsRequestState ===
                            RequestState.LOADING &&
                            !transactionListLastUpdated)
                        }
                        canSort={true}
                        ascending={ascendingTransactions}
                        onSortChange={() => {
                          clearCardTransactions()
                          setCardsTransactionPaginationOffset(0)
                          fetchCardTransactions(
                            cardsTransactionsFilter,
                            0,
                            selectedCard.id,
                            !ascendingTransactions,
                          )
                          setAscendingTransactions((prev) => {
                            return !prev
                          })
                        }}
                      />
                    ) : (
                      <IFFilter
                        ref={operatorUserRef}
                        key={'IFFilter_OperatorUserActions'}
                        onFilterChange={(newFilter) => {
                          setOperatorUserActionsChargingTokenPaginationOffset(0)
                          fetchOperatorUserActionsChargingToken(
                            selectedCard._id,
                            newFilter,
                            0,
                          )
                          setOperatorUserActionsFilter(newFilter)
                        }}
                        filters={operatorUserActionsFilters}
                        textFieldPlaceholder={t(
                          'CardDetails.FilterOperatorUserActionsBy',
                        )}
                        isLoading={
                          fetchCardListRequestState === RequestState.LOADING ||
                          fetchCardRequestState === RequestState.LOADING
                        }
                        disableFutureDates={true}
                      />
                    ))}
                </div>
                {selectedDetails === 0 ? (
                  <ChargingTokenTransactionList
                    ascending={ascendingTransactions}
                  />
                ) : (
                  <OperatorUserActionsChargingToken
                    selectedCard={selectedCard}
                    selectedDetails={selectedDetails}
                  />
                )}
              </div>
            )}
          </OverlayScrollbarsComponent>
        </LeftContainer>

        {selectedCard?.operator ? (
          isEdit ? (
            <div className={Styles.RightContainerEdit}>
              <IFTooltipIconsLoading
                onClick={() => confirmDeleteDialog.current.show()}
                title={t('ChargePointDetails.DeleteButtonText')}
                iconColor={Colors.red}
                iconBackgroundColor={Colors.red}
                Icon={IFsvg.Delete}
                FilledIcon={IFsvg.Delete}
                isLoading={deleteCardRequestState === RequestState.LOADING}
                tooltipPlacement="left"
                size={26}
                iconClassname={Styles.IconContainer}
                style={{ marginRight: '1rem !important' }}
              />
              <IFTooltipIconsLoading
                onClick={handleCancel}
                title={t('ChargePointDetails.CancelButtonText')}
                Icon={IFsvg.Cancel}
                FilledIcon={IFsvg.Cancel}
                isLoading={false}
                tooltipPlacement="left"
                size={26}
                iconClassname={Styles.IconContainer}
                style={{ marginRight: '1rem !important' }}
              />
              <IFTooltipIconsLoading
                onClick={() => {
                  handleSubmitRef.current()
                }}
                title={t('ChargePointDetails.DoneButtonText')}
                Icon={IFsvg.Done}
                FilledIcon={IFsvg.Done}
                isLoading={updateCardRequestState === RequestState.LOADING}
                tooltipPlacement="left"
                size={26}
                iconClassname={Styles.IconContainer}
                style={{ marginRight: '1rem !important' }}
                animationDisabled={false}
              />
            </div>
          ) : fetchCardListRequestState === RequestState.LOADING ||
            cardsList.length > 0 ? (
            <div className={Styles.RightContainer}>
              <div className={Styles.EditButtonContainer}>
                {fetchCardListRequestState === RequestState.LOADING ||
                fetchCardRequestState === RequestState.LOADING ? (
                  <div className={Styles.IconContainerSkeleton}>
                    <IFSkeleton variant="circular" width="26px" height="26px" />
                  </div>
                ) : selectedCard?.status ===
                  InfinityEnums.ChargingTokenStatus.DEACTIVATED ? (
                  <IFTooltipIconsLoading
                    onClick={() => confirmDeleteDialog.current.show()}
                    title={t('ChargePointDetails.DeleteButtonText')}
                    iconColor={Colors.red}
                    iconBackgroundColor={Colors.red}
                    Icon={IFsvg.Delete}
                    FilledIcon={IFsvg.Delete}
                    isLoading={deleteCardRequestState === RequestState.LOADING}
                    tooltipPlacement="left"
                    size={26}
                    iconClassname={Styles.IconContainer}
                    style={{ marginRight: '1rem !important' }}
                  />
                ) : (
                  <IFTooltipIconsLoading
                    onClick={() => {
                      setIsEdit(true)
                    }}
                    title={t('ChargePointDetails.EditButtonText')}
                    Icon={IFsvg.Edit}
                    FilledIcon={IFsvg.Edit}
                    isLoading={false}
                    tooltipPlacement="left"
                    size={26}
                    iconClassname={Styles.IconContainer}
                    style={{ marginRight: '1rem !important' }}
                  />
                )}
              </div>
            </div>
          ) : null
        ) : null}
        <IFDialog
          ref={confirmDeleteDialog}
          title={t('CardDetails.DeleteCard')}
          subtitle={t('CardDetails.DeleteCardSubtitle')}
          onAction={() => deleteCard(selectedCard._id)}
          actionButtonIcon={
            <Icon
              sx={{ width: '18px !important', height: '18px !important' }}
              component={DeleteOutlineIcon}
            />
          }
          actionButtonText={t('CardDetails.DeleteButtonText')}
          actionButtonColor={Colors.red}
          confirmationText={selectedCard?.huid ? selectedCard.huid : ''}
          isLoading={deleteCardRequestState === RequestState.LOADING}
        />
      </div>
    </Fragment>
  )
}

function mapDispatchToProps(dispatch) {
  return {
    clearCardTransactions: () => dispatch(CardActions.clearCardTransactions()),
    resetCardState: () => dispatch(CardActions.resetCardState()),
    setCardTransactionsFilter: (newFilter) =>
      dispatch(CardActions.setCardTransactionsFilter(newFilter)),
    setCardsTransactionPaginationOffset: (offset) =>
      dispatch(CardActions.setCardsTransactionPaginationOffset(offset)),
    fetchCardTransactions: (filter, offset, cardId, ascending) =>
      dispatch(
        CardActions.fetchCardTransactions(filter, offset, cardId, ascending),
      ),
    deleteCard: (cardId) => dispatch(CardActions.deleteCard(cardId)),
    fetchCard: (cardId) => dispatch(CardActions.fetchCard(cardId)),
    updateCard: (cardId, newCard, index) =>
      dispatch(CardActions.updateCard(cardId, newCard, index)),
    fetchOperatorUserActionsChargingToken: (chargingTokenId, filter, offset) =>
      dispatch(
        OperatorUserActionsAction.fetchOperatorUserActionsChargingToken(
          chargingTokenId,
          filter,
          offset,
        ),
      ),
    resetOperatorUserActionsChargingToken: () =>
      dispatch(
        OperatorUserActionsAction.resetOperatorUserActionsChargingToken(),
      ),
    setOperatorUserActionsFilter: (filter) =>
      dispatch(OperatorUserActionsAction.setOperatorUserActionsFilters(filter)),
    setOperatorUserActionsChargingTokenPaginationOffset: (offset) =>
      dispatch(
        OperatorUserActionsAction.setOperatorUserActionsChargingTokenPaginationOffset(
          offset,
        ),
      ),
    resetUpdateCardRequestStates: () =>
      dispatch(CardActions.resetUpdateCardRequestStates()),
  }
}

const mapStateToProps = (state) => ({
  cardsTransactionsFilter: CardSelectors.getCardTransactionsFilter(state),
  selectedIndex: CardSelectors.getSelectedIndex(state),
  fetchCardRequestState: CardSelectors.getFetchCardRequestState(state),
  selectedCard: CardSelectors.getSelectedCard(state),
  cardTransactions: CardSelectors.getCardTransactions(state),
  cardsFilter: CardSelectors.getCardsFilter(state),
  cardsList: CardSelectors.getCards(state),
  fetchCardListRequestState: CardSelectors.getFetchCardListRequestState(state),
  operatorUser: AuthSelectors.getOperatorUser(state),
  updateCardRequestState: CardSelectors.getUpdateCardRequestState(state),
  fetchCardTransactionsRequestState:
    CardSelectors.getFetchCardTransactionsRequestState(state),
  deleteCardRequestState: CardSelectors.getDeleteCardRequestState(state),
  operatorUserActionsFilters:
    OperatorUserActionsSelectors.getOperatorUserActionsFilters(state),
  fetchOperatorUserActionsChargingTokenRequestState:
    OperatorUserActionsSelectors.getFetchOperatorUserActionsChargingTokenRequestState(
      state,
    ),
  cardSessions: CardSelectors.getCardSessions(state),
  fetchCardSessionListRequestState:
    CardSelectors.getFetchCardSessionListRequestState(state),
})

ChargingTokensDetails.propTypes = {
  selectedCard: PropTypes.object,
  selectedIndex: PropTypes.number,
  fetchCardListRequestState: PropTypes.number,
  fetchCardRequestState: PropTypes.number,
  cardsTransactionsFilter: PropTypes.arrayOf(PropTypes.object),
  cardsList: PropTypes.arrayOf(PropTypes.object),
  fetchCard: PropTypes.func,
  clearCardTransactions: PropTypes.func,
  resetCardState: PropTypes.func,
  setCardTransactionsFilter: PropTypes.func,
  setCardsTransactionPaginationOffset: PropTypes.number,
  fetchCardTransactions: PropTypes.func,
  fetchCardTransactionsRequestState: PropTypes.number,
  deleteCard: PropTypes.func,
  deleteCardRequestState: PropTypes.number,
  cardTransactions: PropTypes.arrayOf(PropTypes.object),
  updateCard: PropTypes.func,
  updateCardRequestState: PropTypes.number,
  setOperatorUserActionsFilter: PropTypes.func,
  fetchOperatorUserActionsChargingToken: PropTypes.func,
  resetOperatorUserActionsChargingToken: PropTypes.func,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChargingTokensDetails)
